export enum Language {
  en,
  th
}
